export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "3": "",
        "5": "",
        "10": "",
        "-": "",
        "Aby dodawać użytkowników do wydarzenia musisz najpierw zapisać formularz.": "",
        "Aby dokument był widoczny, należy przypisać go do kategorii.": "",
        "Administracja": "",
        "Administratorzy": "",
        "Adres": "",
        "Adres domenowy": "",
        "Adres e-mail potwierdzony": "",
        "Adres panelu administracyjnego": "",
        "Adres strony": "",
        "Adres strony do osadzenia": "",
        "Adres URL": "",
        "Adres url do pliku wideo": "",
        "Akceptuj": "",
        "Aktualności": "",
        "Aktywne": "",
        "Aktywni": "",
        "Aktywuj przerwę techniczną w witrynie": "",
        "Ankieta przed i po szkoleniu": "",
        "Anonimowy": "",
        "anuluj": "",
        "Anuluj": "",
        "Aranżacja alternatywna": "",
        "Aranżacja główna": "",
        "Archiwizuj": "",
        "Archiwum": "",
        "Artykuł": "",
        "Artykuł jest dostępny dla wszystkich użytkowników": "",
        "Artykuły": "",
        "Artykuły ze strony": "",
        "Asystent AI": "",
        "Automatyczna publikacja galerii": "",
        "Automatyczna publikacja wpisów": "",
        "Autor": "",
        "Autor został dodany.": "",
        "Autor został zaktualizowany.": "",
        "Autorzy": "",
        "Azure": "",
        "Baza dokumentów": "",
        "Bazowy model danych": "",
        "Bez \"http(s)://\" i \"/\" na końcu.": "",
        "Bez zdjęć": "",
        "Blokada konta do": "",
        "Błąd w kolumnie ${error.columnName} w wierszu ${error.actualRow} - ${error.error}": "",
        "Brak": "",
        "Brak artykułów": "",
        "Brak dodanych plików": "",
        "Brak działu nadrzędnego": "",
        "Brak etykiety": "",
        "Brak kategorii": "",
        "Brak kategorii nadrzędnej": "",
        "Brak modułu": "",
        "Brak odpowiedzi dla ankiety": "",
        "Brak plików do dodania": "",
        "Brak powiązań": "",
        "Brak przypisanych zespołów": "",
        "Brak stron": "",
        "Brak strony nadrzędnej": "",
        "Brak wybranych autorów": "",
        "Brak wyników": "",
        "Cechy": "",
        "Chat w szkoleniu": "",
        "CMS": "",
        "co": "",
        "Czas na slajd": "",
        "Czas rozpoczęcia": "",
        "Czas zakończenia": "",
        "Czołówka": "",
        "Czołówka została dodana.": "",
        "Czołówka została usunięta.": "",
        "Czołówka została zaktualizowana.": "",
        "Czy na pewno chcesz wyczyścić pamięć podręczną?": "",
        "Dalej": "",
        "Dane autoryzacyjne Google Analytics": "",
        "Dane autoryzacyjne powinny być przekazane w formacie JSON, który można uzyskać z pliku autoryzacyjnego utworzonego z klucza dostępowego na platformie Google Cloud": "",
        "Dane z formularza zapisywane anonimowo": "",
        "Data": "",
        "Data dezaktywacji": "",
        "Data do": "",
        "Data do której jest wymagane potwierdzenie": "",
        "Data do której jest wymagane potwierdzenie:": "",
        "Data dodania": "",
        "Data końcowa": "",
        "Data modyfikacji": "",
        "Data modyfikacji:": "",
        "Data od": "",
        "Data ostatniego wpisu": "",
        "Data publikacji": "",
        "Data publikacji:": "",
        "Data rejestracji": "",
        "Data rozpoczęcia": "",
        "Data utworzenia": "",
        "Data ważności": "",
        "Data ważności dokumentu": "",
        "Data wysłania": "",
        "Data zakończenia": "",
        "Data zgłoszenia": "",
        "Daty publikacji zostały zaktualizowane.": "",
        "DELETE: Usunięcie wpisu": "",
        "Do akceptacji": "",
        "Dodaj": "",
        "Dodaj czołówkę": "",
        "Dodaj dokument": "",
        "Dodaj dział": "",
        "Dodaj etykietę": "",
        "Dodaj formularz": "",
        "Dodaj galerię": "",
        "Dodaj katalog": "",
        "Dodaj kategorie": "",
        "Dodaj kategorię": "",
        "Dodaj link": "",
        "Dodaj lokalizację": "",
        "Dodaj plik": "",
        "Dodaj slajd": "",
        "Dodaj slajder": "",
        "Dodaj stanowisko": "",
        "Dodaj stronę": "",
        "Dodaj użytkownika": "",
        "Dodaj wątek": "",
        "Dodaj wiadomość": "",
        "Dodaj witrynę": "",
        "Dodaj wpis": "",
        "Dodaj załącznik": "",
        "Dodane pliki z sortowaniem": "",
        "Dodane przez": "",
        "Dodane przez moje zespoły": "",
        "Dodane przeze mnie": "",
        "Dodanie dokumentu": "",
        "Dodanie działu": "",
        "Dodanie galerii": "",
        "Dodanie kategorii": "",
        "Dodanie kategorii wydarzenia": "",
        "Dodanie lokalizacji": "",
        "Dodanie slajdera": "",
        "Dodanie stanowiska": "",
        "Dodanie strony": "",
        "Dodanie wątku": "",
        "Dodanie wpisu": "",
        "Dodanie wydarzenia": "",
        "Dodatki do e-learningu": "",
        "Dodatkowe parametry w adresie URL": "",
        "Dokument": "",
        "Dokument %0": "",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "",
        "Dokument nie ma ustawionej daty publikacji.": "",
        "Dokument został dodany.": "",
        "Dokument został przywrócony z archiwum.": "",
        "Dokument został usunięty.": "",
        "Dokument został zaktualizowany.": "",
        "Dokument został zarchiwizowany.": "",
        "Dokumenty": "",
        "Domyślna witryna": "",
        "Domyślne ustawienie dla witryny": "",
        "Dostęp ": "",
        "Dostęp do": "",
        "Dostęp od": "",
        "Dostęp został zmieniony.": "",
        "Dostępne bloki": "",
        "Dostępne dla": "",
        "Dostępne dla wszystkich": "",
        "Dostępne języki": "",
        "Dostępne moduły": "",
        "Dostępne wersje językowe.": "",
        "Dostępy": "",
        "Dozwolone są tylko małe litery i znak -": "",
        "Dział": "",
        "Dział można opublikować tylko na jednej stronie.": "",
        "Dział nadrzędny": "",
        "Dział został dodany.": "",
        "Dział został usunięty.": "",
        "Dział został zaktualizowany.": "",
        "Działania masowe": "",
        "Działy": "",
        "Dzienny": "",
        "dzień": "",
        "Dzień": "",
        "dzień (dni)": "",
        "Dzień miesiąca": "",
        "E-mail": "",
        "Edycja dokumentu": "",
        "Edycja działów": "",
        "Edycja galerii": "",
        "Edycja kategorii": "",
        "Edycja kategorii wydarzenia": "",
        "Edycja lokalizacji": "",
        "Edycja slajdera": "",
        "Edycja stanowiska": "",
        "Edycja strony": "",
        "Edycja wątku": "",
        "Edycja wpisu": "",
        "Edycja wydarzenia": "",
        "Edytuj": "",
        "Edytuj komentarz": "",
        "Edytuj slajder": "",
        "Edytuj stronę": "",
        "Eksport": "",
        "Email": "",
        "Email potwierdzony": "",
        "Etykieta": "",
        "Etykieta została dodana.": "",
        "Etykieta została usunięta.": "",
        "Etykieta została zaktualizowana.": "",
        "Facebook": "",
        "Facebook Admins": "",
        "Facebook Application ID": "",
        "FavIcona": "",
        "Filtry": "",
        "Formularz": "",
        "Formularz jest wymagany": "",
        "Formularz został utworzony.": "",
        "Forum": "",
        "Galeria": "",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "",
        "Galeria nie ma ustawionej daty publikacji.": "",
        "Galeria zdjęć": "",
        "Galeria została dodana.": "",
        "Galeria została usunięta.": "",
        "Galeria została zaktualizowana.": "",
        "Gazetka": "",
        "Generowanie raportu": "",
        "Generuj": "",
        "Generuj raport": "",
        "Generuj streszczenia do plików": "",
        "Generuj wszystkie metadane": "",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "",
        "GET: Pobranie danych": "",
        "GET: Pobranie wpisu": "",
        "GET: Schemat (definicja formularza)": "",
        "Google": "",
        "Google Maps": "",
        "Hasło": "",
        "Hierarchiczny": "",
        "i posiadających wymagane uprawnienia": "",
        "Id": "",
        "ID": "",
        "Identyfikator usługi Google Analytics": "",
        "Ikona": "",
        "Ikona jest wymagana": "",
        "Ikona wyświetlana jest w postaci kwadratu.": "",
        "Ilość": "",
        "Ilość artykułów w kategorii": "",
        "Ilość kolumn podkategorii": "",
        "Ilość wydarzeń": "",
        "Ilość wyświetlanych artykułów": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Imię i nazwisko/nazwa autora": "",
        "Imię lub nazwisko": "",
        "Import": "",
        "Import użytkowników": "",
        "Indywidualny": "",
        "Indywidualny z terminu spotkań": "",
        "Informacja o błędzie": "",
        "Informacja o ciasteczkach": "",
        "Inspekcja": "",
        "Integracje": "",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "",
        "Język": "",
        "Język domyślny": "",
        "Kalendarz": "",
        "Kanały": "",
        "Katalog": "",
        "Katalog linków": "",
        "Kategoria": "",
        "Kategoria jest wymagana": "",
        "Kategoria linku": "",
        "Kategoria nadrzędna": "",
        "Kategoria nie jest jeszcze nigdzie opublikowana.": "",
        "Kategoria wydarzenia": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Kategorie wydarzeń": "",
        "Kategorię": "",
        "Kategorię można opublikować tylko na jednej stronie.": "",
        "Kod Bing Webmaster": "",
        "Kod Google Webmaster": "",
        "Kod GTM": "",
        "Kolor": "",
        "Kolor tekstu": "",
        "Kolor tła": "",
        "Kolumny": "",
        "Komentarz": "",
        "Komentarz %0": "",
        "Komentarze": "",
        "Konfiguracja": "",
        "Konfiguruj stronę": "",
        "Koniec po": "",
        "Konto aktywne": "",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
        "Konto z dostępem do panelu": "",
        "Konto zanonimizowane": "",
        "Kopiuj": "",
        "Kreator modułu": "",
        "Krótki opis": "",
        "Krótki tytuł": "",
        "Ldap": "",
        "Liczba ankiet": "",
        "Liczba dni od pierwszego logowania": "",
        "Liczba dni od pierwszego logowania:": "",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "",
        "Liczba wydarzeń": "",
        "Liczba wyników na stronie": "",
        "Liczba wyświetlanych slajdów": "",
        "Liczba zaimportowanych użytkowników: ${importInformations?.importedAccounts}": "",
        "Liczba zgłoszeń:": "",
        "Lider/koordynator dla wszystkich zespołów": "",
        "Limit dodanych linków": "",
        "Link": "",
        "Link do strony": "",
        "Link został dodany.": "",
        "Link został usunięty.": "",
        "Link został zaktualizowany.": "",
        "Lista artykułów": "",
        "Lista jest pusta": "",
        "Lista linków": "",
        "Lista propozycji użytkowników do oznaczenia": "",
        "Lista wydarzeń": "",
        "Logo": "",
        "Lokalizacja": "",
        "Lokalizacja została dodana.": "",
        "Lokalizacja została usunięta.": "",
        "Lokalizacja została zaktualizowana.": "",
        "Lokalizacje": "",
        "Lokalizowane": "",
        "Lokalne": "",
        "Ładowanie zgłoszeń...": "",
        "Marketing": "",
        "Metadane": "",
        "mies.": "",
        "miesiąc": "",
        "Miesiąc": "",
        "Miesięczny": "",
        "Miniatura zdjęcia": "",
        "Model danych": "",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "",
        "Moduł": "",
        "Moduł dynamiczny": "",
        "Moduł spotkań": "",
        "Moduł został dodany.": "",
        "Moduły": "",
        "Moduły wyszukiwarki": "",
        "Moje dokumenty": "",
        "Monitor kolejek": "",
        "Monitoring": "",
        "Możliwość dodawania linków przez użytkownika": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "",
        "Multimedia": "",
        "Najwyższy poziom": "",
        "Narzędzia": "",
        "Nazwa": "",
        "Nazwa adresu": "",
        "Nazwa certyfikatu": "",
        "Nazwa czołówki": "",
        "Nazwa dokumentu": "",
        "Nazwa działu": "",
        "Nazwa etykiety": "",
        "Nazwa formularza": "",
        "Nazwa jest wymagana": "",
        "Nazwa kategorii": "",
        "Nazwa Kategorii": "",
        "Nazwa linku": "",
        "Nazwa lokalizacji": "",
        "Nazwa modułu": "",
        "Nazwa musi mieć co najmniej 4 znaki": "",
        "Nazwa nie może być dłuższa niż 30 znaków": "",
        "Nazwa pliku": "",
        "Nazwa sekcji w menu": "",
        "Nazwa slajdera": "",
        "Nazwa slajdu": "",
        "Nazwa stanowiska": "",
        "Nazwa strony": "",
        "Nazwa szablonu": "",
        "Nazwa szkolenia": "",
        "Nazwa użytkownika": "",
        "Nazwa użytkownika - intralearn": "",
        "Nazwa w panelu": "",
        "Nazwa wątku": "",
        "Nazwa witryny": "",
        "Nazwa wyświetlana": "",
        "Nazwa wyświetlana:": "",
        "Nazwa:": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie ma jeszcze żadnego działu.": "",
        "Nie ma jeszcze żadnych kategorii.": "",
        "Nie ma jeszcze żadnych rekordów": "",
        "Nie masz uprawnień do zarządzania uprawnieniami": "",
        "Nie można przypisać strony do działu, który nie jest działem głównym.": "",
        "Nie można usunąć strony przypisanej do działu głównego.": "",
        "Nie można usunąć swojego konta.": "",
        "Nie udało się pobrać listy aranżacji": "",
        "Nie udało się pobrać listy bloków": "",
        "Nie udało się pobrać listy działów": "",
        "Nie udało się pobrać listy etykiet": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się pobrać listy lokalizacji": "",
        "Nie udało się pobrać listy modułów": "",
        "Nie udało się pobrać listy modułów wyszukiwarki": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy stanowisk": "",
        "Nie udało się pobrać listy stron": "",
        "Nie udało się pobrać listy szablonów": "",
        "Nie udało się pobrać listy zespołów do których jest przypisany użytkownik": "",
        "Nie udało się ustawić aranżacji domyślnej": "",
        "Nie udało się załadować ankiet.": "",
        "Nie wszystkie pola zostały wypelnione prawidłowo.": "",
        "Nie wybrano strony": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nieaktywne": "",
        "Nieaktywni": "",
        "Niepotwierdzeni": "",
        "Niepubliczne": "",
        "Niestandardowy adres": "",
        "Niestandardowy adres strony": "",
        "Nieudane logowania": "",
        "Nowa kategoria": "",
        "Number": "",
        "Numer": "",
        "Numer komórkowy": "",
        "Numer pracownika": "",
        "Numer telefonu": "",
        "Numer telefonu komórkowego": "",
        "Odrzuć": "",
        "Odznacz wszystkie": "",
        "Ok": "",
        "Okładka": "",
        "Opcja pozwala na przypisywanie do tej kategorii wydarzeń dodanych przez wszystkich użytkowników": "",
        "Opis": "",
        "Opis kategorii": "",
        "Opis przerwy technicznej": "",
        "Opublikowane": "",
        "Opublikowane języki": "",
        "Opublikowane wersje językowe.": "",
        "Opublikuj": "",
        "Opublikuj autora": "",
        "Opublikuj dział": "",
        "Opublikuj wątek": "",
        "Opublikuj wpis": "",
        "Organizacja": "",
        "Otwórz na nowej karcie": "",
        "Otwórz stronę w nowym oknie": "",
        "Otwórz w nowej karcie": "",
        "Pamięć podręczna": "",
        "Pamięć podręczna została wyczyszczona.": "",
        "Pełna treść:": "",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "",
        "Plik": "",
        "Plik wideo": "",
        "Pliki": "",
        "Pliki do dodania": "",
        "Po aktywacji wejście na dowolną stronę frontową przez użytkownika w obrębie witryny wyświetli informację o trwającej przerwie technicznej. Witryna podczas przerwy technicznej dla użytkowników z uprawnieniami administratora jest zawsze dostępna.": "",
        "Po zapisaniu wydarzenia nie można zmienić witryny i wersji językowej": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "",
        "Podaj nazwę formularza": "",
        "Podgląd strony": "",
        "Podstawowe": "",
        "Pojedynczy artykuł (strona opisowa)": "",
        "Pokaż dla wybranych zespołów lub użytkowników": "",
        "Pokaż listę wpisów": "",
        "Pokaż wyniki z ostatnich dni": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Język\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole \"Witryna\" jest wymagane.": "",
        "Pole nie może zawierać spacji": "",
        "Polecenie dla asystenta AI": "",
        "Polubienia": "",
        "Polubienia włączone": "",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "",
        "POST: Upload załączników": "",
        "POST: Utworzenie wpisu": "",
        "POST: Zapisanie zmian": "",
        "Potwierdzenie archiwizacji": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie przywrócenia z archiwum": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie zatwierdzenia": "",
        "Potwierdź akceptację": "",
        "Potwierdź usunięcie": "",
        "Powiadomienia dla użytkowników": "",
        "Powiadomienie zostało dodane do kolejki.": "",
        "Powiązane artykuły": "",
        "Powiązany artykuł": "",
        "Powiązany autor": "",
        "Powód": "",
        "Powód odrzucenia": "",
        "Powrót": "",
        "Powtarzaj co": "",
        "Powtórz hasło": "",
        "Pozostałe": "",
        "Pozostałe ustawienia": "",
        "Pozycja": "",
        "Premium": "",
        "Profil został zaktualizowany.": "",
        "Proste uprawnienia": "",
        "Przefiltrowani użytkownicy": "",
        "Przerwa techniczna": "",
        "Przypomnienie": "",
        "Przywróć": "",
        "Przywróć z archiwum": "",
        "Przywróć zaznaczone": "",
        "Publiczne": "",
        "Publiczne ID:": "",
        "Publikacja": "",
        "Publikacja galerii przez użytkownika": "",
        "Publikacja wpisów przez użytkownika": "",
        "Publikacja została dodana.": "",
        "Publikacja została usunięta.": "",
        "Publikuj do": "",
        "Publikuj na stronie": "",
        "Publikuj na witrynie": "",
        "Publikuj od": "",
        "PUT: Aktualizacja wpisu": "",
        "Ranga": "",
        "Raport został wygenerowany.": "",
        "Regulaminy": "",
        "Relacyjne": "",
        "Rest API": "",
        "Roczny": "",
        "Rodzaj wydarzenia": "",
        "rok": "",
        "Rola": "",
        "Role użytkownika": "",
        "Sekcja": "",
        "Sekcja %0": "",
        "Sekcja modułu": "",
        "Skrypty zewnętrzne": "",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "",
        "Slajder": "",
        "Slajder został dodany.": "",
        "Slajder został usunięty.": "",
        "Slajder został zaktualizowany.": "",
        "Slajdery": "",
        "Sortowanie dokumentów": "",
        "Sortowanie działów": "",
        "Sortowanie kategorii": "",
        "Sortowanie linków": "",
        "Sortuj dokumenty": "",
        "Sortuj kategorie": "",
        "Sortuj linki": "",
        "Specjalizowane": "",
        "Standardowe uprawnienia": "",
        "Standardowy": "",
        "Stanowiska": "",
        "Stanowisko pracy": "",
        "Stanowisko zostało dodane.": "",
        "Stanowisko zostało usunięte.": "",
        "Stanowisko zostało zaktualizowane.": "",
        "Status": "",
        "Status dokumentu": "",
        "Status dokumentu został zmieniony.": "",
        "Status galerii został zmieniony.": "",
        "Status linku został zmieniony.": "",
        "Status powiadomienia": "",
        "Status użytkownika": "",
        "Status:": "",
        "Streszczenie dla pliku ' + f.fileName + ' zostało wygenerowane": "",
        "Strona": "",
        "Strona błędu": "",
        "Strona deklaracja dostępności": "",
        "Strona docelowa dla 'Kontakt z adminem'": "",
        "Strona docelowa dla 'Pliki cookies'": "",
        "Strona docelowa dla 'Polityka prywatności'": "",
        "Strona dostępna dla wszystkich": "",
        "Strona dostępna tylko dla zalogowanych użytkowników": "",
        "Strona nadrzędna": "",
        "Strona opublikowana": "",
        "Strona ukryta": "",
        "Strona z modułu konto użytkownika": "",
        "Strona została dodana.": "",
        "Strona została usunięta.": "",
        "Strona została zaktualizowana.": "",
        "Strona/kategoria nadrzędna": "",
        "Symbol": "",
        "Symbol autora": "",
        "Symbol jest wymagany": "",
        "Symbol modułu": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol musi mieć co najmniej 4 znaki": "",
        "Symbol nie może być dłuższy niż 20 znaków": "",
        "Symbol strony": "",
        "Symbol w adresie URL": "",
        "Synchronizacja użytkowników": "",
        "Synchronizuj": "",
        "System": "",
        "Szablon graficzny": "",
        "Szablon importu": "",
        "Szablon modułu": "",
        "Szczegóły": "",
        "Szczegóły wpisu": "",
        "Szkic": "",
        "Szkolenia": "",
        "Ta opcja dodaje użytkownika do wszystkich zespołów z zaznaczoną opcją Lidera i pozwala koordynatorowi widzieć wszystko w profilu koordynatora. Również do nowo utworzonych zespołów będzie  on ustawiał się jako Lider.": "",
        "Tagi": "",
        "Tak": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Termin cykliczny": "",
        "Termin jednorazowy": "",
        "Terminy": "",
        "Tło w widoku logowania": "",
        "Tokeny": "",
        "Treść": "",
        "Treść komentarza": "",
        "Treść wpisu": "",
        "Tryb wyświetlania": "",
        "tydzień (tygodnie) w następującym dniu": "",
        "Tygodniowy": "",
        "Tylko aktualne": "",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "",
        "Tylko przeterminowane": "",
        "Tylko treść": "",
        "Tylko zarchiwizowane": "",
        "Tylko ze zdjęciami": "",
        "Typ konta": "",
        "Typ obiektu:": "",
        "Typ strony": "",
        "Typ wyboru ikony": "",
        "Typ wyświetlanych artykułów": "",
        "Tytuł": "",
        "Tytuł przerwy technicznej": "",
        "Tytuł strony": "",
        "Tytuł witryny": "",
        "Ukryj godzinę wydarzenia": "",
        "Uprawnienia": "",
        "URL": "",
        "Ustaw kategorię": "",
        "Ustaw również dla wszystkich podstron": "",
        "Ustawienia": "",
        "Ustawienia dostępności": "",
        "Ustawienia generowania streszczeń": "",
        "Ustawienia konta": "",
        "Ustawienia polubień": "",
        "Ustawienia slajdera": "",
        "Ustawienia strony": "",
        "Ustawienia witryny": "",
        "Ustawienia zostały zaktualizowane.": "",
        "Ustawienia zostały zapisane.": "",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nCzy na pewno chcesz usunąć wybrany formularz?": "",
        "Usuń": "",
        "Usuń artykuł z listy": "",
        "Usuń autora": "",
        "Usuń plik": "",
        "Usuń powiązanie": "",
        "Usuń slajd": "",
        "Usuń stronę": "",
        "Usuń zaznaczone": "",
        "Utwórz formularz": "",
        "Uzasadnij odrzucenie": "",
        "Użytkownik": "",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik zalogowany": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został zaktualizowany.": "",
        "Użytkowników": "",
        "W następującym dniu:": "",
        "Wątek został dodany.": "",
        "Wątek został usunięty.": "",
        "Wątek został zaktualizowany.": "",
        "Wątki": "",
        "Wersje": "",
        "Wersjonowany": "",
        "Wideo": "",
        "Widoczna dla wszystkich użytkowników": "",
        "Widoczność konta": "",
        "Wiersz ${error.actualRow}: błąd w kolumnie ${error.columnName} - ${error.error}": "",
        "Witryna aktywna": "",
        "Witryna domyślna": "",
        "Witryna i język": "",
        "Witryna tylko dla zalogowanych użytkowników": "",
        "Witryna została dodana.": "",
        "Witryna została usunięta.": "",
        "Witryna została zaktualizowana.": "",
        "Właściwości": "",
        "Włącz ankietę": "",
        "Włącz formularz": "",
        "Włączenie obsługi cacheu dla witryny": "",
        "Włączenie protokołu SSL dla tej witryny": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wpis został dodany.": "",
        "Wpis został usunięty.": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisy": "",
        "Wpisy zostały usunięte.": "",
        "Wpisy zostały zaakceptowane.": "",
        "Wstecz": "",
        "Wstęp": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wszystkie kategorie": "",
        "Wszystko": "",
        "Wybierz ankietę": "",
        "Wybierz artykuł": "",
        "Wybierz autora": "",
        "Wybierz formularz": "",
        "Wybierz istniejącego użytkownika": "",
        "Wybierz kategorię": "",
        "Wybierz kategorię dokumentu.": "",
        "Wybierz kategorię linku.": "",
        "Wybierz przełożonego": "",
        "Wybierz stronę": "",
        "wybierz szablon": "",
        "Wybierz szkolenie": "",
        "Wybierz użytkownika": "",
        "wybierz...": "",
        "Wybór dokumentów": "",
        "Wybór kategorii wydarzeń": "",
        "Wybór osób": "",
        "Wybór z listy": "",
        "Wybrana ikona powinna być kwadratem": "",
        "Wybrane szkolenie nie jest opublikowane": "",
        "Wybranie modułu jest wymagane": "",
        "Wybranie sekcji jest wymagane": "",
        "Wybranie strony jest wymagane": "",
        "Wybrano": "",
        "Wybrany szablon": "",
        "Wyczyszczenie pamięci podręcznej może spowodować usunięcie niezapisanych postępów czasu spędzonego na platformie.": "",
        "Wyczyść pamięć podręczną": "",
        "Wydarzenie dostępne tylko w module spotkań": "",
        "Wygląd": "",
        "Wyłącz komentarze dla tego artykułu": "",
        "Wyłącz udostępnij dalej": "",
        "Wyłączone wysyłanie powiadomień": "",
        "Wymaga potwierdzenia": "",
        "Wymaga potwierdzenia do podanej daty": "",
        "Wymaga potwierdzenia od pierwszego logowania": "",
        "Wymuś zmianę hasła": "",
        "wystąpieniach": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd podczas próby pobrania szablonu.": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wyszukaj": "",
        "Wyszukaj autora...": "",
        "Wyszukaj użytkownika...": "",
        "Wyślij powiadomienie e-mail": "",
        "Wyślij powiadomienie o aktualizacji dokumentu": "",
        "Wyświetl w ulubionych": "",
        "Wyświetlaj na stronie głównej": "",
        "Wyświetlaj tylko treść": "",
        "Wyświetlaj zdjęcie na stronie głównej ": "",
        "wyświetleń": "",
        "Wzorzec cyklu": "",
        "z": "",
        "Zaakceptowany": "",
        "Zaawansowane uprawnienia": "",
        "zacznij pisać aby wyszukać ankiety...": "",
        "zacznij pisać aby wyszukać artykuł...": "",
        "zacznij pisać aby wyszukać autora...": "",
        "zacznij pisać aby wyszukać przełożonego...": "",
        "zacznij pisać aby wyszukać szkolenie...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zaimportowano listę użytkowników.": "",
        "Zakres cyklu": "",
        "Załączniki": "",
        "Zamknij": "",
        "Zamknij i pobierz": "",
        "Zapisz": "",
        "Zapisz artykuł, aby móc zarządzać uprawnieniami": "",
        "Zapisz i wróć": "",
        "Zastępstwa": "",
        "Zatwierdź": "",
        "Zatwierdź zaznaczone": "",
        "Zaznacz wszystkie": "",
        "Zaznaczone": "",
        "Zaznaczone (${checkedItems.value.length})": "",
        "Zdjęcie": "",
        "Zdjęcie autora": "",
        "Zdjęcie dla tabletów": "",
        "Zdjęcie dla urządzeń mobilnych": "",
        "Zdjęcie główne": "",
        "Zdjęcie użytkownika": "",
        "Zdjęcie/ikonka": "",
        "Zespoły": "",
        "Zespoły użytkownika": "",
        "Zespół": "",
        "Zewnętrzne skrypty statystyk": "",
        "Zewnętrzne skrypty targetujące": "",
        "Zgłoszenia": "",
        "Zmiana symbolu powoduje również zmianę adresu URL.": "",
        "Zmiany zostały zapisane.": "",
        "Zmień daty publikacji": "",
        "Zobacz wszystkich użytkowników": "",
        "Zobacz wszystkie artykuły": "",
        "Zobacz wszystkie galerie": "",
        "Zwrócony": "",
        "Źródło": "",
        "Źródło URL": ""
    }
};
